/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const CloneSolidV6 = (props) => (
  <Icon {...props} name="Clone Solid V6">
    <path d="M0 7a2 2 0 0 1 2-2h2v4c0 1.656 1.316 3 3 3h4v2c0 1.103-.897 2-2 2H2a2 2 0 0 1-2-2V7zm7 4c-1.103 0-2-.897-2-2V2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7c0 1.103-.897 2-2 2H7z" />
  </Icon>
);

export default CloneSolidV6;
